import { useQuery } from '@tanstack/react-query'

import requests from 'service/api'

import SearchSelect from '../search-select'
import { useFormikContext } from 'formik'
import { useEffect, useState, useMemo } from 'react'

export function SelectFabricTypePrice12({ name, idx, idx2, idx3,brrand ,index }) {
  const { values } = useFormikContext()
  const [selected, setSelected] = useState(null)
  
  // Safe access to the path
  const path = values.zaraHomeLabel12?.[idx]?.fabric?.[idx2]?.mix?.[idx3]?.type || ''

  const { data, isFetched } = useQuery({
    queryKey: ['/list', 'fabricType'],
    queryFn: async () => {
      if (brrand === "ZaraHome") {
        const { data } = await requests.fabric.typeListHome()
        return data
      } else {
        const { data } = await requests.fabric.typeList()
        return data
      }
    },
    placeholderData: []
  })

  const options = useMemo(() => data?.map(({ id, name }) => ({
    value: name,
    label: name
  })) || [], [data])

  useEffect(() => {
    if (path && path.length > 0 && isFetched && options.length > 0) {
      const select = options.find(({ value }) => value === path)
      setSelected(select)
    } else {
      // Reset selection if no valid data
      setSelected(null)
    }
    // eslint-disable-next-line
  }, [path, isFetched, idx3, options])

  return (
    <SearchSelect name={name} options={options} value={selected} onChange={(e) => setSelected(e)} />
  )
}
